module.exports = __webpack_public_path__ + "img/dummy2.2713ce03.jpg";